import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useSnackbar} from 'notistack'

import {mutations} from '@settings/api/mutations'
import {ErrorResponse} from '@settings/modules/common/types'

export const useCreateJanusKpis = () => {
  const {enqueueSnackbar, closeSnackbar} = useSnackbar()

  return useMutation<
    void,
    AxiosError<ErrorResponse>,
    Parameters<typeof mutations.createJanusKpis>[0]
  >({
    mutationFn: mutations.createJanusKpis,
    onSuccess: () => {
      enqueueSnackbar('Kpis updated succesfully', {
        variant: 'success',
        autoHideDuration: 2500,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'center'
        },
        onClick: () => closeSnackbar()
      })
    },
    onError: (error) => {
      enqueueSnackbar(`Kpis could not be updated: ${error.message}`, {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'center'
        },
        onClick: () => closeSnackbar()
      })
    }
  })
}
